// Business contact details. Edit these values to update the site.
export const BUSINESS = {
  name: "Mymi Global Business",
  // TODO: replace this placeholder with your actual customer-facing email.
  email: "contact@mymiglobal.com",
  phone: "(973) 816-3230",
  phoneRaw: "9738163230",
  address: "35 O'Brien St, Unit G7, Kearny, NJ 07032",
  hours: "Every day, 10:00 AM – 8:00 PM",
  social: {
    // TODO: replace with your actual Facebook page URL.
    facebook: "https://facebook.com/mymiglobalbusiness",
    // WhatsApp click-to-chat link uses your business phone.
    whatsapp: "https://wa.me/19738163230",
  },
  mapsQuery: "35+O'Brien+St+Unit+G7+Kearny+NJ+07032",
};
